import { xSequentialFill } from 'ml-spectra-processing';
import { apodization } from '../apodization/apodization';
import { signalsToSpinSystem } from './simulation/signalsToSpinSystem';
import { simulateXYPeaks } from './simulation/simulateXYPeaks';
import { splitSpinSystem } from './simulation/splitSpinSystem';
const twoPi = Math.PI * 2;
/**
 * it use the chemical shifts and the coupling between them in order to generate a FID.
 * It does not propagate the hamiltonian of the spin system, instead it simulate all the
 * frequencies in the spectrum (including second order) and add all the waves in a real and
 * imaginary parts, that is why the couplings should be assigned in order to generate the spin system.
 */
export function signalsToFID(signals, options) {
    const { lb = 1, from = 0, to = 10, nbPoints = 1024, frequency = 400, maxClusterSize = 8, } = options;
    let spinSystem = signalsToSpinSystem(signals);
    spinSystem.clusters = splitSpinSystem(spinSystem, {
        frequency,
        maxClusterSize,
    });
    const peaks = simulateXYPeaks(spinSystem, { frequency });
    const re = new Float64Array(nbPoints);
    const im = new Float64Array(nbPoints);
    const sw = Math.abs(to - from);
    const adquisitionTime = nbPoints / (sw * frequency);
    const time = xSequentialFill({
        size: nbPoints,
        from: 0,
        to: adquisitionTime,
    });
    for (const peak of peaks) {
        const { x, y } = peak;
        const cs = x * frequency * twoPi;
        for (let i = 0; i < nbPoints; i++) {
            re[i] += y * Math.cos(cs * time[i]);
            im[i] += y * Math.sin(cs * time[i]);
        }
    }
    const { windowData, ...result } = apodization({ re, im }, {
        pointsToShift: 0,
        compose: {
            length: nbPoints,
            shapes: [
                {
                    start: 0,
                    shape: {
                        kind: 'exponential',
                        options: {
                            dw: adquisitionTime / (nbPoints - 1),
                            lb,
                        },
                    },
                },
            ],
        },
    });
    return result;
}
//# sourceMappingURL=signalsToFID.js.map